import { Locale } from '@headless-workspace/config';
import { ServerErrorCode } from '@headless-workspace/data';
import { CommonDI, LoggerType } from '../../../DI';
import { checkMemoCountrySelectorFeatureFlag } from '../countrySpecificities';
import { FooterSlotsValue } from '../footer';
import { CategoryValue } from '../navigation';
import {
    getMemoCatalogCategories,
    getMemoPersistentBannerSlot,
    getMemoPopularSearches,
    getMemoFooterSlots,
} from '../preload';
import { PageManager } from './PageManager';

export type RootPageParams = Partial<{
    categories: CategoryValue[];
    footerSlots: FooterSlotsValue;
}>;

type RootPreloadParams = {
    locale: Locale;
};

export const RootPageManager: PageManager<RootPageParams, RootPreloadParams> = {
    canGeneratePage({ categories, footerSlots }: RootPageParams): boolean {
        return (
            !!categories?.length &&
            // footer compliance is commented as it is missing on some locale like pl-PL
            // !!footerSlots?.compliance?.length &&
            !!footerSlots?.links.length &&
            // footer reinsurance is commented as it is missing on some locale like tr-TR
            // !!footerSlots?.reinsurance.length &&
            !!footerSlots?.socialNetwork.length
        );
    },

    preloadPageData({ locale }: RootPreloadParams): void {
        Promise.allSettled([
            getMemoCatalogCategories(locale),
            getMemoFooterSlots(locale),
            getMemoPersistentBannerSlot(locale),
            getMemoPopularSearches(locale),
            checkMemoCountrySelectorFeatureFlag(locale),
        ]).catch((error) => {
            CommonDI.get(LoggerType).error(ServerErrorCode.PagePreload, error);
        });
    },
};
